"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _EventSummaryResponse = _interopRequireDefault(require("../models/EventSummaryResponse"));

var _DataResponse = _interopRequireDefault(require("../models/DataResponse"));

var _DataSecurableResponse = _interopRequireDefault(require("../models/DataSecurableResponse"));

var _Storable = _interopRequireDefault(require("../models/Storable"));

var _PagedResponse = _interopRequireDefault(require("../models/PagedResponse"));

var _PagedSecurableResponse = _interopRequireDefault(require("../models/PagedSecurableResponse"));

var _ReportResponse = _interopRequireDefault(require("../models/ReportResponse"));

var _Stream = _interopRequireDefault(require("../models/Stream"));

/**
 * Event service.
 * @module ChiRhos/api/EventApi
 * @version v1
 */
var EventApi =
/*#__PURE__*/
function () {
  /**
   * Constructs a new EventApi.
   * @alias module:ChiRhos/api/EventApi
   * @class
   * @param {module:ChiRhos/ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ChiRhos/ApiClient#instance} if unspecified.
   */
  function EventApi(apiClient) {
    (0, _classCallCheck2["default"])(this, EventApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * @param {Object} opts Optional parameters
   * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  (0, _createClass2["default"])(EventApi, [{
    key: "_addFavouriteWithHttpInfo",
    value: function _addFavouriteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event/Favourite/Add', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "AddFavourite",
    value: function AddFavourite(opts) {
      return this._addFavouriteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:ChiRhos/models/DataResponse>} and HTTP response
     */

  }, {
    key: "_attendListReportWithHttpInfo",
    value: function _attendListReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/Report/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:ChiRhos/models/DataResponse>}
     */

  }, {
    key: "AttendListReport",
    value: function AttendListReport(opts) {
      return this._attendListReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_attendMaybeWithHttpInfo",
    value: function _attendMaybeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/Maybe', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "AttendMaybe",
    value: function AttendMaybe(opts) {
      return this._attendMaybeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_attendNoWithHttpInfo",
    value: function _attendNoWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/No', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "AttendNo",
    value: function AttendNo(opts) {
      return this._attendNoWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_attendYesWithHttpInfo",
    value: function _attendYesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/Yes', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "AttendYes",
    value: function AttendYes(opts) {
      return this._attendYesWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_deleteWithHttpInfo",
    value: function _deleteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Delete",
    value: function Delete(opts) {
      return this._deleteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.importIdentifier
     * @param {Boolean} opts.createDependencies  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/Storable} and HTTP response
     */

  }, {
    key: "_importWithHttpInfo",
    value: function _importWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        ContentType: opts['contentType'],
        ContentDisposition: opts['contentDisposition'],
        Headers: opts['headers'],
        Length: opts['length'],
        Name: opts['name'],
        FileName: opts['fileName'],
        importIdentifier: opts['importIdentifier'],
        createDependencies: opts['createDependencies']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Storable["default"];
      return this.apiClient.callApi('/api/Event/Import', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.importIdentifier
     * @param {Boolean} opts.createDependencies  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/Storable}
     */

  }, {
    key: "Import",
    value: function Import(opts) {
      return this._importWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_checkInWithHttpInfo",
    value: function _checkInWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/CheckIn', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "CheckIn",
    value: function CheckIn(opts) {
      return this._checkInWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByCodeRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_checkInByAttendanceCodeWithHttpInfo",
    value: function _checkInByAttendanceCodeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/CheckInByAttendanceCode', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByCodeRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "CheckInByAttendanceCode",
    value: function CheckInByAttendanceCode(opts) {
      return this._checkInByAttendanceCodeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByPersonRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_checkInByPersonCodeWithHttpInfo",
    value: function _checkInByPersonCodeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/CheckInByPersonCode', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByPersonRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "CheckInByPersonCode",
    value: function CheckInByPersonCode(opts) {
      return this._checkInByPersonCodeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceMultipleRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_checkInMultipleWithHttpInfo",
    value: function _checkInMultipleWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event/Attend/CheckInMultiple', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceMultipleRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "CheckInMultiple",
    value: function CheckInMultiple(opts) {
      return this._checkInMultipleWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_checkOutWithHttpInfo",
    value: function _checkOutWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/CheckOut', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventAttendanceRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "CheckOut",
    value: function CheckOut(opts) {
      return this._checkOutWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByCodeRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_checkOutByAttendanceCodeWithHttpInfo",
    value: function _checkOutByAttendanceCodeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/CheckOutByAttendanceCode', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByCodeRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "CheckOutByAttendanceCode",
    value: function CheckOutByAttendanceCode(opts) {
      return this._checkOutByAttendanceCodeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByPersonRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_checkOutByPersonCodeWithHttpInfo",
    value: function _checkOutByPersonCodeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/CheckOutByPersonCode', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByPersonRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "CheckOutByPersonCode",
    value: function CheckOutByPersonCode(opts) {
      return this._checkOutByPersonCodeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_deleteResourceWithHttpInfo",
    value: function _deleteResourceWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event/Resource/Delete', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "DeleteResource",
    value: function DeleteResource(opts) {
      return this._deleteResourceWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/ReportResponse} and HTTP response
     */

  }, {
    key: "_executeAttendanceReportWithHttpInfo",
    value: function _executeAttendanceReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _ReportResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/Report/Execute', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/ReportResponse}
     */

  }, {
    key: "ExecuteAttendanceReport",
    value: function ExecuteAttendanceReport(opts) {
      return this._executeAttendanceReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/ReportResponse} and HTTP response
     */

  }, {
    key: "_executeReportWithHttpInfo",
    value: function _executeReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _ReportResponse["default"];
      return this.apiClient.callApi('/api/Event/Report/Execute', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/ReportResponse}
     */

  }, {
    key: "ExecuteReport",
    value: function ExecuteReport(opts) {
      return this._executeReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_getWithHttpInfo",
    value: function _getWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Event/Get', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Get",
    value: function Get(opts) {
      return this._getWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByCodeRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_getByCodeWithHttpInfo",
    value: function _getByCodeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Event/GetByCode', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventByCodeRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "GetByCode",
    value: function GetByCode(opts) {
      return this._getByCodeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_getNoteWithHttpInfo",
    value: function _getNoteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Note/Get', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "GetNote",
    value: function GetNote(opts) {
      return this._getNoteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/Stream} and HTTP response
     */

  }, {
    key: "_getResourceFileWithHttpInfo",
    value: function _getResourceFileWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Stream["default"];
      return this.apiClient.callApi('/api/Event/Resource/File', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/Stream}
     */

  }, {
    key: "GetResourceFile",
    value: function GetResourceFile(opts) {
      return this._getResourceFileWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_listAttendanceForEventWithHttpInfo",
    value: function _listAttendanceForEventWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/ListForEvent', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "ListAttendanceForEvent",
    value: function ListAttendanceForEvent(opts) {
      return this._listAttendanceForEventWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_listForGroupWithHttpInfo",
    value: function _listForGroupWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Event/ListForGroup', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "ListForGroup",
    value: function ListForGroup(opts) {
      return this._listForGroupWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_listNotesWithHttpInfo",
    value: function _listNotesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Event/Note/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "ListNotes",
    value: function ListNotes(opts) {
      return this._listNotesWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {String} entityId
     * @param {Date} from
     * @param {Date} to
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:ChiRhos/models/EventSummaryResponse>} and HTTP response
     */

  }, {
    key: "_listOpenWithHttpInfo",
    value: function _listOpenWithHttpInfo(entityId, from, to) {
      var postBody = null; // verify the required parameter 'entityId' is set

      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling listOpen");
      } // verify the required parameter 'from' is set


      if (from === undefined || from === null) {
        throw new Error("Missing the required parameter 'from' when calling listOpen");
      } // verify the required parameter 'to' is set


      if (to === undefined || to === null) {
        throw new Error("Missing the required parameter 'to' when calling listOpen");
      }

      var pathParams = {
        entityId: entityId,
        from: from,
        to: to
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = [_EventSummaryResponse["default"]];
      return this.apiClient.callApi('/api/Event/ListOpen/{EntityId}/{From}/{To}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {String} entityId
     * @param {Date} from
     * @param {Date} to
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:ChiRhos/models/EventSummaryResponse>}
     */

  }, {
    key: "ListOpen",
    value: function ListOpen(entityId, from, to) {
      return this._listOpenWithHttpInfo(entityId, from, to).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Date} from
     * @param {Date} to
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:ChiRhos/models/EventSummaryResponse>} and HTTP response
     */

  }, {
    key: "_listOpenForHighlightedWithHttpInfo",
    value: function _listOpenForHighlightedWithHttpInfo(from, to) {
      var postBody = null; // verify the required parameter 'from' is set

      if (from === undefined || from === null) {
        throw new Error("Missing the required parameter 'from' when calling ListOpenForHighlighted");
      } // verify the required parameter 'to' is set


      if (to === undefined || to === null) {
        throw new Error("Missing the required parameter 'to' when calling ListOpenForHighlighted");
      }

      var pathParams = {
        from: from,
        to: to
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = [_EventSummaryResponse["default"]];
      return this.apiClient.callApi('/api/Event/ListOpenForHighlighted/{From}/{To}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Date} from
     * @param {Date} to
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:ChiRhos/models/EventSummaryResponse>}
     */

  }, {
    key: "ListOpenForHighlighted",
    value: function ListOpenForHighlighted(from, to) {
      return this._listOpenForHighlightedWithHttpInfo(from, to).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:ChiRhos/models/DataResponse>} and HTTP response
     */

  }, {
    key: "_listReportWithHttpInfo",
    value: function _listReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Report/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:ChiRhos/models/DataResponse>}
     */

  }, {
    key: "ListReport",
    value: function ListReport(opts) {
      return this._listReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedSecurableResponse} and HTTP response
     */

  }, {
    key: "_listResourcesWithHttpInfo",
    value: function _listResourcesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedSecurableResponse["default"];
      return this.apiClient.callApi('/api/Event/Resource/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedSecurableResponse}
     */

  }, {
    key: "ListResources",
    value: function ListResources(opts) {
      return this._listResourcesWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Before an occurrence of an event series can be used, it must be &#39;materialized&#39; to turn it into a full event
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventMaterializeRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_materializeWithHttpInfo",
    value: function _materializeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Event/Materialize', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Before an occurrence of an event series can be used, it must be &#39;materialized&#39; to turn it into a full event
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventMaterializeRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Materialize",
    value: function Materialize(opts) {
      return this._materializeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/EventConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_saveWithHttpInfo",
    value: function _saveWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Event', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/EventConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Save",
    value: function Save(opts) {
      return this._saveWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiAddNoteRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_saveNoteWithHttpInfo",
    value: function _saveNoteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Note', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiAddNoteRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "SaveNote",
    value: function SaveNote(opts) {
      return this._saveNoteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.resourceJson
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_saveResourceWithHttpInfo",
    value: function _saveResourceWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        ContentType: opts['contentType'],
        ContentDisposition: opts['contentDisposition'],
        Headers: opts['headers'],
        Length: opts['length'],
        Name: opts['name'],
        FileName: opts['fileName'],
        resourceJson: opts['resourceJson']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Event/Resource/Save', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.resourceJson
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "SaveResource",
    value: function SaveResource(opts) {
      return this._saveResourceWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_restoreWithHttpInfo",
    value: function _restoreWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event/Restore', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Restore",
    value: function Restore(opts) {
      return this._restoreWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * The Filters collection will filter the Events
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/ReportResponse} and HTTP response
     */

  }, {
    key: "_runAttendanceReportWithHttpInfo",
    value: function _runAttendanceReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _ReportResponse["default"];
      return this.apiClient.callApi('/api/Event/Attend/Report/Run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * The Filters collection will filter the Events
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/ReportResponse}
     */

  }, {
    key: "RunAttendanceReport",
    value: function RunAttendanceReport(opts) {
      return this._runAttendanceReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/ReportResponse} and HTTP response
     */

  }, {
    key: "_runReportWithHttpInfo",
    value: function _runReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _ReportResponse["default"];
      return this.apiClient.callApi('/api/Event/Report/Run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/ReportResponse}
     */

  }, {
    key: "RunReport",
    value: function RunReport(opts) {
      return this._runReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_saveAttendanceReportWithHttpInfo",
    value: function _saveAttendanceReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event/Attend/Report/Save', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "SaveAttendanceReport",
    value: function SaveAttendanceReport(opts) {
      return this._saveAttendanceReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_saveAttendanceReportForGroupTypeWithHttpInfo",
    value: function _saveAttendanceReportForGroupTypeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event/Attend/Report/SaveForGroupType', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "SaveAttendanceReportForGroupType",
    value: function SaveAttendanceReportForGroupType(opts) {
      return this._saveAttendanceReportForGroupTypeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_saveReportWithHttpInfo",
    value: function _saveReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event/Report/Save', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "SaveReport",
    value: function SaveReport(opts) {
      return this._saveReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_saveReportForGroupTypeWithHttpInfo",
    value: function _saveReportForGroupTypeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Event/Report/SaveForGroupType', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "SaveReportForGroupType",
    value: function SaveReportForGroupType(opts) {
      return this._saveReportForGroupTypeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Lists all events for the current person for the next 2 months after the specified date. This is &#39;as of now&#39; and cannot be in the past
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventsUpcomingRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_upcomingWithHttpInfo",
    value: function _upcomingWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Event/Upcoming', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Lists all events for the current person for the next 2 months after the specified date. This is &#39;as of now&#39; and cannot be in the past
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEventsUpcomingRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "Upcoming",
    value: function Upcoming(opts) {
      return this._upcomingWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
  }]);
  return EventApi;
}();

exports["default"] = EventApi;
module.exports = exports.default;